import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { TChatbotAgent } from '~/features/agents/models'
import { queryKeys } from '~/features/agents/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import { HttpServiceBaseResponse } from '~/services/http/models'
import pathBuilder from '~/utils/api'

type TParams = {
  legacyChatbotId: string
  queryOptions?: Partial<
    UseQueryOptions<HttpServiceBaseResponse<TChatbotAgent>>
  >
}

const useGetAgentByLegacyChatbotId = ({
  legacyChatbotId,
  queryOptions,
}: TParams) => {
  return useQuery({
    queryKey: queryKeys.agents({ legacyChatbotId }),
    queryFn: () =>
      HttpService.get<TChatbotAgent>(
        {
          path: pathBuilder(EServerPath.guestAgentByLegacyChatbotId, {
            legacyChatbotId,
          }),
        },
        EHttpService.guestAgent,
      ),
    enabled: !!legacyChatbotId,
    retry: false,
    ...queryOptions,
  })
}

export default useGetAgentByLegacyChatbotId
